<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="$t('log.breadcrumb')" :title="$t('log.title')">
      <div class="list__buttons"></div>
    </ToolsPanel>
    <ContentContainer>
      <div class="list">
        <div v-if="logList.length">
          <div class="list__table">
            <CustomTable
              v-if="logList.length"
              :data="logList"
              :deleted-keys="tableOptions.deletedKeys"
              :rename-columns="tableOptions.renameColumn"
              :custom-order="tableOptions.customOrder"
              :is-action-block-visible="tableOptions.isActionBlockVisible"
              :handleFilter="handleFilter"
              :direction="directionSort"
              :order="orderSort"
              :name="'log'"
            >
            </CustomTable>
          </div>
          <div class="pagination">
            <Pagination
              :maxPage="log.lastPage"
              :page="page"
              :urlList="'LOG'"
              :totalItem="log.total"
            />
          </div>
        </div>
        <div class="list__no-have" v-else>No log found by this parameter.</div>
      </div>
    </ContentContainer>

    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />

    <MainModal v-if="detailModal" :on-close="handleCloseDetailModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-column">
          <div class="list__confirm-title">Detail</div>
        </div>

        <div class="list__confirm-column">
          <div class="list__confirm-title">Log List</div>
        </div>
      </div>
    </MainModal>

    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import leadApi from "~/api/lead";
import moment from "moment";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ModalError from "~/components/molecules/ModalError.vue";

export default {
  name: "LogList",
  metaInfo: {
    title: "Log List",
  },
  data() {
    return {
      logsModal: false,
      logsModalArray: [],
      deleteModal: false,
      deleteRow: null,
      deleteModalSuccess: false,
      directionSort: false,
      orderSort: "log_created_at",

      detailModal: false,
      chosenLead: null,

      tableOptions: {
        deletedKeys: ["null"],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "log_created_at",
            to: "Created At",
          },
          {
            from: "logType",
            to: "Type",
          },
          {
            from: "logEvent",
            to: "Event",
          },
          {
            from: "leadId",
            to: "lead id",
          },
          {
            from: "countryId",
            to: "country",
          },
          {
            from: "integrationId",
            to: "integration id",
          },
          {
            from: "statusId",
            to: "status id",
          },
          {
            from: "created",
            to: "created",
          },
          {
            from: "copies",
            to: "copies",
          },
          {
            from: "skipped",
            to: "skipped",
          },
          {
            from: "entityId",
            to: "entity id",
          },
        ],
        customOrder: [
          "log_created_at",
          "logType",
          "logEvent",
          "leadId",
          "countryId",
          "integrationId",
          "entityId",
          "statusId",
          "created",
          "copies",
          "skipped",
          "null",
        ],
      },
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    // MainButton,
    CustomTable,
    Pagination,
    MainModal,
    ModalError,
  },
  mounted() {
    this.getList();
  },
  watch: {
    $route(to, from) {
      this.getList();
    },
  },
  computed: {
    ...mapState("lead", ["error", "loadingProcess", "log", "logList"]),
    page() {
      return +this.$route.params.page;
    },
  },
  methods: {
    getList() {
      let url = `?page=${this.page}`;
      if (this.orderSort.length) {
        url =
          url +
          `&perPage=10&sortField=${this.orderSort}&sortDest=${this.directionSort ? "asc" : "desc"}`;
      }
      this.$store.dispatch("lead/getLogList", url);
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getList();
    },

    handleDetail(row) {
      this.detailModal = true;
      this.chosenLead = this.leadsList.find((item) => item.id === row.id);
    },
    handleCloseDetailModal() {
      this.detailModal = false;
      this.chosenLead = null;
    },
    closeModal() {
      this.error = null;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.custom-table__header,
/deep/.custom-table__row {
  grid-template-columns: 120px repeat(10, 120px) !important;
}

.list {
  &__table {
    overflow-x: auto;
    width: calc(100vw - 290px);
  }

  /deep/.custom-table {
    width: fit-content;
  }
}
</style>
